"use strict";

angular.module("customer")
.controller("NotificationHistoryController", function($scope, $timeout, $stateParams, REFRESH_NOTIFICATION_LISTING) {
    if ($stateParams.filterUnread) { $scope.filterUnread = $stateParams.filterUnread; }

    this.reloadListing = function() {
        $timeout(function () {
            $scope.$broadcast(REFRESH_NOTIFICATION_LISTING, $scope.filterUnread);
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/notification/notification-history.controller.js
// module id = 940
// module chunks = 0